/*
 * � 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/CardLogic/IDailyAuthority',[],function () {
    var IDailyAuthority = function () {
        this.TotalMoves = 0;
        this.TimerEnabled = 0;
        this.MovesAllowed = 0;
        this.StartingTime = 0;
        this.DeckSeeds = [];
        this.ChallengeType = IDailyAuthority.ChallengeType.Unknown;
        this.SetDealScript = function (script) {};
        this.SetNumBoardsCompleted = function (numBoards) {};
    };

    IDailyAuthority.ChallengeType =
    {
        AchieveScore: 0,
        BuildStacks: 1,
        CardToCard: 2,
        ClearBoards: 3,
        ClearRows: 4,
        PlayCard: 5,
        PlayValues: 6,
        SolveGame: 7,
        Unknown: 8
    };

    return IDailyAuthority;
});
